import { render } from "./CopyrightPage.vue?vue&type=template&id=14e3d5f2"
import script from "./CopyrightPage.vue?vue&type=script&lang=js"
export * from "./CopyrightPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__